import { configureStore } from '@reduxjs/toolkit'

import normalDataReducer from './reducers/normalDataReducer'
import recruitingDataReducer from './reducers/recruitingDataReducer'
import userReducer from './reducers/userReducer'
import goalsReducer from './reducers/goalsReducer'
import popupsReducer from './reducers/popupsReducer'

export default configureStore({
  reducer: {
    normalData: normalDataReducer,
    recruitingData: recruitingDataReducer,
    user: userReducer,
    goals: goalsReducer,
    popups: popupsReducer
  },
})